/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.
*/

export const USERNAME_MAX_LENGTH = 126;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 64;

export type UsernameError = "missing" | "invalid" | "too-long";
export type PasswordError = "missing" | "too-short" | "too-long";

const USERNAME_REGEX = /^[a-zA-Z0-9._~-]+$/;

export function validateUsername(value: string): UsernameError | undefined {
  if (!value) return "missing";
  if (value.length > USERNAME_MAX_LENGTH) return "too-long";
  if (!USERNAME_REGEX.test(value)) return "invalid";
  return undefined;
}

export function validatePassword(
  value: string,
  enforceLength: boolean,
): PasswordError | undefined {
  if (!value) return "missing";
  if (!enforceLength) return undefined;
  if (value.length < PASSWORD_MIN_LENGTH) return "too-short";
  if (value.length > PASSWORD_MAX_LENGTH) return "too-long";
  return undefined;
}

export function isBlankName(value: string): boolean {
  return value.trim().length === 0;
}
